import React, { useEffect, useState } from 'react';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import VimeoWidget from '~/components/Common/Forms/widgets/VimeoWidget';

interface Props {
  isSaving?: boolean;
  open: boolean;
  videoId?: string;
  onClose: () => void;
  onSave: (videoId: string) => void | Promise<void>;
}

export default function VideoEditorDialog({ isSaving = false, open, videoId, onClose, onSave }: Props) {
  const [draftVideoId, setDraftVideoId] = useState('');

  useEffect(() => {
    if (open) {
      setDraftVideoId(videoId ?? '');
    }
  }, [open, videoId]);

  const handleSave = async () => {
    try {
      await onSave(draftVideoId.trim());
    } catch {
      return;
    }
  };

  return (
    <Dialog open={open} onClose={isSaving ? undefined : onClose} maxWidth="md" fullWidth>
      <DialogTitle>Replace video</DialogTitle>
      <DialogContent>
        <VimeoWidget value={draftVideoId} onChange={setDraftVideoId} />
      </DialogContent>
      <DialogActions>
        <Button variant="text" disabled={isSaving} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress size={18} color="inherit" /> : undefined}
          onClick={handleSave}
        >
          {isSaving ? 'Saving video' : 'Save video'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
